import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { UiPathComponent } from '@app/uipath.component';
import {
    AuthService,
    ModalService,
} from '@services';

@Injectable()
export class ModalGuard implements CanDeactivate<UiPathComponent> {
    constructor(
        private _modalService: ModalService,
        private _authService: AuthService,
    ) { }

    canDeactivate() {
        if (
            this._authService
                .pendingLogout$
                .value
        ) {
            return true;
        }

        // if the open dialogs can be closed, proceed
        return this._modalService
            .dialog
            .openDialogs
            .reduce(
                (prev, dialog) => prev &&
                    !dialog.disableClose,
                true,
            );
    }
}
